module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-04.93ac3aaf.svg";